import './bookmark.less';
import { addToBookmark, removeFromBookmark } from 'vueCommon/api/bookmarkService.js';

/**
 * Проверяет, является ли пользователь гостем, и если да - показывает попап регистрации
 * @param {Function} successCb - Callback функция, которая выполнится если пользователь авторизован
 * @param {string} page - Страница для попапа регистрации
 */
const filterGuest = (successCb, page) => {
    if (window.config.user.isGuest) {
        $.fancybox({
            href: '/?r=user/signupPopup/page/' + page,
            type: 'ajax',
        });
    } else {
        successCb();
    }
};

/**
 * Объект для работы с закладками (избранным)
 */
const bookmark = {
    hideSpeed: 150,

    /**
     * Добавляет товар в избранное
     * @param {HTMLElement|jQuery} elem - Элемент закладки
     * @param {number|string|null} [price] - Опциональная цена товара
     */
    add (elem) {
        const element = $(elem);
        if (element.hasClass('added')) {
            return;
        }

        let goodCode = this._findGoodCode(element);
        const finalPrice = $('.price-internet').data('price') ?? null;

        if (finalPrice) {
            // Цена только у заказной продукции, меняем на IM кода товара
            // Цену нужно передавать, чтобы установить скидку за ожидание
            goodCode = $('.cart-add').attr('id');
        }

        filterGuest(async () => {
            addToBookmark({
                goodCode: goodCode,
                price: finalPrice ?? null,
            }).then(() => {
                element.addClass('added');
                element.attr('title', 'Убрать из избранного');
            });
        }, 'bookmark');
    },

    /**
     * Удаляет товар из избранного
     * @param {HTMLElement|jQuery} elem - Элемент закладки
     */
    remove (elem) {
        const element = $(elem);
        let goodCode = this._findGoodCode(element);

        const finalPrice = $('.price-internet').data('price') ?? null;

        if (finalPrice) {
            goodCode = $('.cart-add').attr('id');
        }

        filterGuest(async () => {
            removeFromBookmark({
                goodCode: goodCode,
            }).then(() => {
                element.removeClass('added');
                element.attr('title', 'Добавить в избранное');
            });
        }, 'bookmark');
    },
    _findGoodCode: function (elem) {
        var element = $(elem);
        var price = element.closest('.price');

        if (!price.length) {
            return element.data('good-code');
        }

        return price.find('.cart-add').attr('id');
    },

};

/**
 * Инициализация обработчиков событий для закладок
 */
$(function () {
    const bookmarks = $('.bookmark');

    bookmarks.filter('.hiding').on(
        'hover',
        function () {
            $(this).find('.text').show();
        },
        function () {
            $(this).find('.text').hide();
        }
    );

    $('.bookmark').on('click', function () {
        const $bookmark = $(this);

        if ($bookmark.hasClass('added')) {
            bookmark.remove(this);
        } else if (!$bookmark.hasClass('remove-existing')) {
            bookmark.add(this);
        }
    });
});
